import type { ReactNode } from 'react';
import React, { Component } from 'react';

import { MiniMapError } from './MiniMapError';

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class MiniMapErrorBoundary extends Component<any, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <MiniMapError />;
      // You can render any custom fallback UI
    }

    return this.props.children;
  }
}
